"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfPropertyExtists = function (modelName) { return function (property) {
    var value = property.value;
    if (!value) {
        // tslint:disable-next-line
        console.log(value);
        throw new Error("Property " + property.key + " not found on " + modelName);
    }
    return value;
}; };
